"use client";

import { useEffect, useState } from "react";

import { formatTagText } from "@/app/ec/product/[basePath]/createEditManufacturerPromo";
import { PreviewManufacturerPromoModal } from "@/app/ec/product/[basePath]/manufacturer-promotions/previewManufacturerPromoModal";

import PromoTagIcon from "public/next-public/common/icons/promo-tag.svg";

import styles from "./productDetailPagePromotionTagBox.module.scss";

function ProductDetailPagePromotionTagBox({ promotion }: ProductDetailPagePromotionTagBoxProps) {
  const [promoModalOpen, setPromoModalOpen] = useState(false);
  const [formattedPdpTagText, setFormattedPdpTagText] = useState<PdpTagTextBox>();
  const onOpenTextClick = () => {
    setPromoModalOpen(true);
  };

  useEffect(() => {
    setFormattedPdpTagText(formatTagText(promotion?.pdpTagText ?? ""));
  }, []);

  const beforeText = (formattedPdpTagText?.beforeText ?? "").trim();
  const afterText = (formattedPdpTagText?.afterText ?? "").trim();
  const offerLinkText = (formattedPdpTagText?.openText ?? "").replace(/\s*>{2,}\s*$/, "").trim();

  return (
    <div className={styles.PromotionTagBox}>
      {promotion && (
        <>
          <span className={styles.tag}>
            <PromoTagIcon className={styles.icon} width={16} height={16} aria-hidden />
            <span>{beforeText}</span>
          </span>
          {offerLinkText && (
            <button type="button" onClick={onOpenTextClick} className={styles.openText}>
              {offerLinkText}
            </button>
          )}
          {afterText && <span className={styles.afterText}>{afterText}</span>}
          <PreviewManufacturerPromoModal
            showModal={promoModalOpen}
            promoInfo={promotion}
            manufacturerLogoLink={promotion?.manufacturerLogoPath}
            onCloseModal={() => setPromoModalOpen(false)}
          />
        </>
      )}
    </div>
  );
}

export type ProductDetailPagePromotionTagBoxProps = {
  promotion?: ManufacturerPromotionDetail;
  callStatus: string | undefined;
};

export type PdpTagTextBox = {
  openText: string;
  beforeText: string;
  afterText: string;
};
export default ProductDetailPagePromotionTagBox;
